module.exports = __webpack_public_path__ + "img/int1.8d939766.jpg";